<template>
  <div>
    <el-form ref="taskInfo" :model="taskInfo" :rules="taskInfoRules" :label-width="labelwidth" label-position="right">
      <el-row>
        <el-col :span="9">
          <el-form-item label="任务名称:" prop="executionName">
            <el-input class="el-form-input" v-model="taskInfo.executionName" placeholder="问卷标题1"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="截止时间:" prop="executionValidateTo">
            <el-date-picker
              class="el-form-input w-full"
              type="datetime"
              placeholder="选择时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="taskInfo.executionValidateTo"
              :picker-options="startDateDisabled"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col :span="12">
          <el-form-item prop="executionQuantity" class="answerNum" label-width="170px">
            <template slot="label" style="display: flex;">
              <span>每名调查员回收答卷数:</span>
               <el-tooltip content="每名调查员需要完成的答卷数量" placement="top">
                <i class="el-icon-question"></i> 
              </el-tooltip> 
            </template>
            <el-input
              class="el-form-input"
              v-model="taskInfo.executionQuantity"
              placeholder="请输入数量"
            ></el-input>
          </el-form-item>
        </el-col>    
      </el-row>
      <el-row>
        <el-col :span="9">
          <el-form-item prop="executionSingleAmount">
            <template slot="label" style="display: flex;">
                <span>答卷单价:</span>
                 <el-tooltip content="“答卷单价”为回收答卷质控通过后调查员的到手金额" placement="top">
                  <i class="el-icon-question"></i> </el-tooltip
                >: 
            </template>
            <el-input
              class="el-form-input"
              v-model="taskInfo.executionSingleAmount"
              placeholder="支持两位小数，支持0和正数"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="15">
          <el-form-item label="预估费用:">
            {{ money }} 元
            <p class="inline-block ml-6" v-if="Number(GlobalConfig.getCompanyId())">推荐您通过调研工厂与调查员进行结算，为您节约成本 <a class="text-blue cursor-pointer" @click="getMore">了解更多</a></p>
          </el-form-item>
        </el-col>    
      </el-row> -->

      <el-form-item label="描述:">
        <el-input class="el-form-input" v-model="taskInfo.executionDescription" placeholder="请输入内容"></el-input>
      </el-form-item>
      <el-form-item label="执行要求:">
        <el-input class="el-form-input" v-model="taskInfo.executionRequirement" placeholder="请输入内容"></el-input>
      </el-form-item>
      <el-form-item label="质控标准:" prop="qualityControlStandard">
        <el-input class="el-form-input" v-model="taskInfo.qualityControlStandard" placeholder="请输入内容"></el-input>
      </el-form-item>
      <el-form-item v-if="type!=='proxy'" label-width="200px" label="调查完成后是否实时上传数据:" prop="realTimeSubmit">
        <el-switch
          v-model="taskInfo.realTimeSubmit"
          :active-value="1"
          :inactive-value="0">
        </el-switch>
      </el-form-item>
      <!-- <el-form-item label="结算标准:">
        <el-input class="el-form-input" v-model="taskInfo.settleStandard" placeholder="请输入内容"></el-input>
      </el-form-item> -->
      <el-form-item v-if="type == 'proxy'" required label="代理是否审核答卷:">
        <!-- <el-radio-group v-model="taskInfo.flag">
          <el-radio :label="1">需要</el-radio>
          <el-radio :label="0">不需要</el-radio>
        </el-radio-group> -->
        <el-switch v-model="taskInfo.flag"></el-switch>
      </el-form-item>
    </el-form>
    <OnlinePayService ref="onlinePayServiceVisible" />
  </div>
</template>
<script>
import { isNum } from '@/assets/js/utils'
import OnlinePayService from '@/components/online-pay-service'
import GlobalConfig from '@/global/config'
import { mapGetters } from 'vuex'

const testNum = /((^[0-9]\d*)|^0)(\.\d{0,2})?$/
export default {
  components: { OnlinePayService },
  created() {
    let len = this.$route.query.len || 1
    this.taskInfo.executionName = this.title + len // '电话访问' + len
  },
  data() {
    const executionNameRules = (rule, value, callback) => {
      let v = this.taskInfo.executionName
      if (!v.trim()) {
        callback(new Error('请输入任务名称'))
      }
      callback()
    }
    const executionQuantityRules = (rule, value, callback) => {
      let v = this.taskInfo[rule.fullField]
      if (!isNum.test(v)) {
        callback(new Error('请输入有效数字'))
      }
      if (rule.fullField === 'executionSingleAmount') {
      } else if (v <= 0) {
        callback(new Error('不能为0'))
      }
      callback()
    }
    const executionSingleAmountRules = (rule, value, callback) => {
      let v = this.taskInfo[rule.fullField]
      if (!testNum.test(v)) {
        let _v = Number(v)
        console.log(_v)
        if (!isNaN(_v)) {
          callback(new Error('最多支持两位小数，仅支持0和正数'))
        } else {
          callback(new Error('请输入有效数字'))
        }
      }
      callback()
    }
    const executionValidateToRules = (rule, value, callback) => {
      let v = this.taskInfo.executionValidateTo
      if (!v) {
        callback(new Error('请选择结束时间'))
      }
      callback()
    }
    const qualityControlStandardValidateToRules = (rule, value, callback) => {
      let v = this.taskInfo.qualityControlStandard
      if (!v) {
        callback(new Error('请输入质控标准'))
      }
      callback()
    }
    const startDateDisabled = {}
    startDateDisabled.disabledDate = function (time) {
      return time.getTime() + 24 * 3600 * 1000 < Date.now()
    }
    return {
      GlobalConfig,
      startDateDisabled,
      taskInfo: {
        executionName: '',
        settleStandard: '',
        realTimeSubmit: 0
      },
      taskInfoRules: {
        executionName: [{ required: true, validator: executionNameRules, trigger: 'blur' }],
        // qualityControlStandard:[
        //   { required: true,
        //     message:'请输入质控标准',
        //     trigger: 'blur'
        //   }
        // ],
        executionQuantity: [
          {
            required: true,
            validator: executionQuantityRules,
            trigger: 'blur'
          }
        ],
        executionSingleAmount: [
          {
            required: true,
            validator: executionSingleAmountRules,
            trigger: 'blur'
          }
        ],
        executionValidateTo: [
          {
            required: true,
            validator: executionValidateToRules,
            trigger: 'blur'
          }
        ],
      }
    }
  },
  props: {
    type: String,
    labelwidth: {
      type: String,
      default: '90px'
    }
  },
  computed: {
    money() {
      let { executionQuantity = 0, executionSingleAmount = 0 } = this.taskInfo
      return ((executionQuantity * 100 * executionSingleAmount) / 100 || 0).toFixed(2)
    },
    ...mapGetters(['title']),
  },
  methods: {
    getMore() {
      this.$refs.onlinePayServiceVisible.openDialog()
    }
  },
  watch: {
    taskInfo(val) {
      this.$emit('childTaskMes', val)
    }
  }
}
</script>
<style lang="scss" scoped>
.answerNum {
  ::v-deep .el-form-item__label {
    display: flex !important;
  }
}
.el-date-editor {
  width: 100%;
}
</style>
